/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

export class AddOnNoRouter extends AddOn {
	protected baseVasCode: String = 'ROUTER-OWN';
	constructor() {
		super();
		this.key = 'AddOnNoRouter';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Not Router';
		this.boxNameZh = 'Not Router';
		this.boxAmount = 999; // refer only
		this.discountAmount = 0; // 3080 // 2160 // 1860
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public getPlanVasCode(): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			vasCode = this.getBaseVasCode() + '';
			return vasCode;
		} else {
			return '';
		}
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================
}
